export default "__VITE_ASSET__sdnGo3o6__"